import { Component, ElementRef, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, PopoverController, AlertController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment'
import { CalendarPage } from '../../calendar/calendar';
import { AlertsaddPage } from '../alerts/alertsadd';
import { EditdrivergradePage } from './editdrivergrade/editdrivergrade';
import { EditvehshiftsPage } from '../editvehshifts/editvehshifts';
import { PopupPage } from '../../popup/popup';
import { ExcludearmPage } from '../../excludearm/excludearm';
import { PopupadddriverPage } from './popupadddriver/popupadddriver';
import { ImgcostsPage } from '../../costs/imgcosts/imgcosts';
import { File } from '@ionic-native/file';
/**
 * Generated class for the VehicleeditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vehicleedit',
  templateUrl: 'vehicleedit.html',
})
export class VehicleeditPage {
  @ViewChild("myfile") fileInput: ElementRef;

  HaveUploadFile = false;
  pdflink = 'https://panorama.gps.mk/costimg/pdf-s.png'

  selectedTime = new Date().getHours() + 1 + ":00";
  selectedTimeEwt = new Date().getHours() + 1 + ":00";
  selectedTimeLastServ = new Date().getHours() + 1 + ":00";

  codeInventory = ''
  brandSap = ''
  infoNote = ''
  motorSerialNum = ''

  Title = ''
  VehicleID = ''
  VehicleData: any
  Drivers = []
  garminQuickMessages = []
  vehiclesGarminComm = []

  vehDrivers = []
  vehAlerts = []
  _registration = ''
  _sasija = ''
  _firstregistration = ''
  _firstregistrationDT
  _code = ''
  _lastregistration = ''
  _lastregistrationDT

  _lastinsurance = ''
  _lastinsuranceDT

  // pp aparat
  _lastfireextinguisher = ''
  _lastfireextinguisherDT

  //megunarodna licenca
  _intLicenceFrom = ''
  _intLicenceFromDT
  _intLicenceTo = ''
  _intLicenceToDT

  // _vehicleOdometar = ''
  // _vehicleOdometarDT = ''

  _odometarDate: any = new Date()
  _odometarDateStr: any = moment().format('DD-MM-YYYY')
  _odometarDateYMD: any = moment().format('YYYY-MM-DD')

  _ewtDate: any = new Date()
  _ewtDateStr: any = moment().format('DD-MM-YYYY')
  _ewtDateYMD: any = moment().format('YYYY-MM-DD')


  _lastservicedtmanual: any = new Date()
  _lastservicedtmanualStr: any = moment().format('DD-MM-YYYY')
  _lastservicedtmanualYMD: any = moment().format('YYYY-MM-DD')
  _lastservicekmmanual = ''

  _info = ''
  _model = ''

  _speedlimitalertallow = false; //se setira od nasiot admin - dali klientot ja ima plateno ovaa usluga za ova vozilo
  _speedlimitalertenable = false; //dali da mu notificira vo app
  _speedlimittolerance = '0'; //so koja tolerancija da raboti (0.1 = 10%, 0.3 = 30% , >1 znaci nad x Km/h pr. 20 = 20 Km/h)
  _apprkmyear = ''
  _summer = ''
  _brand = ''
  _myear = ''
  _winter = ''
  _fueltype = ''
  _printtravelorder = ''
  _sinterval = ''
  _skm = ''
  _swh = ''
  _ounit = ''
  // _odometer = ''
  _motor = ''
  _livevisible = false

  _autorenewregistration = false;
  _autorenewfireextinguisher = false;

  _fuelcapacity = ''
  _greencard = false
  _consumptionshow = false
  _addequip = ''
  loadingData = false
  _changefuelcap = false;
  _hasfuel = false
  alerts: any = [];
  origAlerts: any = [];

  gradeDriver: any = [];

  Odometer = ''
  engineWorkTime = ''

  prazniAlerti: any = []
  fromVehicle = 1
  fromVehicleNew = 1

  allowCanbas = ''

  _multiplefueltypes = false

  _enterpredmess = ''
  _messforall = false
  _vehGarmin = '-1'
  //Motor = Seriski broj na ured
  Drivers2 = []
  routingTab: string = 'geninfo'
  //start demo tender - samo za addinfo (demo - vtor segment)
  _osovini = '2_4'
  _euro = 'e1'
  _tacho = 'ta'
  _radio = 'rcd'
  _nabavkadt = moment().format(this.gn.user.DFormat)
  _inspekcija = 'it'
  _rezinspekcija = 'rp'
  //end demo tender


  licenceimg = '/';
  licencepdf = '/';

  constructor(public loadingCtrl: LoadingController, public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    if (this.gn.user.ClientId == 711 || this.gn.user.ClientId == 357) {
      this.codeInventory = this.dic.l["Inventarenbroj"]
      this.brandSap = this.dic.l["brandSapDic"]
      this.infoNote = this.dic.l["note"]
      this.motorSerialNum = this.dic.l["motorSerialNumber"]



    }
    else {
      this.codeInventory = this.dic.l["code"]
      this.brandSap = this.dic.l["brand"]
      this.infoNote = this.dic.l["info"]
      this.motorSerialNum = this.dic.l["Motor"]

    }
    // console.log(this.gn.user.metricvalue,'daj da vidam')
    this.VehicleID = navParams.get('vehicleid')
    // this._vehicleOdometar = moment().format(this.gn.user.DFormat)
    // this._vehicleOdometarDT = this._vehicleOdometar
    this._odometarDateStr = moment(this._odometarDate).format('DD-MM-YYYY')
    this._ewtDateStr = moment(this._ewtDate).format('DD-MM-YYYY')

    this._lastservicedtmanualStr = moment(this._lastservicedtmanual).format('DD-MM-YYYY')

    // var utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
    // document.write(utc,'mozno li e datum da vidam');

    // console.log(utc,' daj da vidam datum')
    // console.log(moment().format('YYYY-MM-DD HH:MM:SS'))






    // console.log(this.VehicleID,'daj mi id na vozilo')
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad VehicleeditPage');
    this.loadVehicleData()
    this.loadDrivers()
    this.getCurrkm()
    this.getCurrEngineWorkTime()
    this.getAllAlertsforVeh()
    this.getGrade()
    if (this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]].allowgarmin + '' == '1') {
      this.loadGarminQuickMessages();
    }
    // this.openTimePopup()

  }

  editGrade() {
    var _that = this
    let modal = this.modalCtrl.create(EditdrivergradePage, {
      gradeD: _that.gradeDriver,
      cb: function (_gspeed, _grpm, _gidle) {
        _that.gradeDriver.gradespeedlimit = _gspeed
        _that.gradeDriver.graderpmlimit = _grpm
        _that.gradeDriver.gradeidleminuteslimit = _gidle
      }
    }, { cssClass: "modal-fullscreen-beacon" });
    modal.present();
  }
  // openTimePopup(_ev) {
  //   var _that = this
  //   let popover = this.popoverCtrl.create(PopupPage, {
  //     type: 'time', selected: [], callback: function (text, ids) {
  //       // console.log(_text, _ids)
  //       // that.selectedVehiclesIds = ids
  //       // that.selectedVehiclesText = text

  //       _that.selectedTime = text;

  //       // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
  //     }
  //   });
  //   popover.present({
  //     ev: _ev
  //   });
  // }

  loadGarminQuickMessages() {
    var _that = this
    this.gn._Post('/api/gn/getallgarminquickemessages', { vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      _that.garminQuickMessages = _data
      _that.gn._Post('/api/gn/getallvehiclesgarmincomm', { vid: _that.gn.crypt(_that.VehicleID), cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), rid: _that.gn.crypt(_that.gn.user.RoleId) }, function (_data1) {
        _that.vehiclesGarminComm = _data1
      })
    })
  }

  loadDrivers() {
    var _that = this
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.Drivers = _data
      console.log('dali vlagastuka 2 pati')
      _that.Drivers2 = _data
    })
  }


  getGrade() {
    var _that = this;
    this.gradeDriver = [];
    this.gn._Post('/api/gn/getGradeDriver', { vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      _that.gradeDriver = _data[0];
    })
  }

  getAllAlertsforVeh() {
    var _that = this;
    this.alerts = [];
    this.origAlerts = [];
    this.gn._Post('/api/gn/getallalarmVehicle', { cid: this.gn.crypt(this.gn.user.ClientId), vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      // console.log(_data);
      _that.origAlerts = _data;
      var lastuniqid = "";
      var cntUniqID = 0;

      for (let i = 0; i < _data.length; i++) {
        if ((_data[i].alarmtypeid + '' == '8' || _data[i].alarmtypeid + '' == '9' || _data[i].alarmtypeid + '' == '10') && _data[i].poiname == null)
          continue;

        _data[i].alarmDescription = '';

        if (_data[i].alarmtypeid + '' == '17' || _data[i].alarmtypeid + '' == '20' || _data[i].alarmtypeid + '' == '79' || _data[i].alarmtypeid + '' == '103') {
          if (_data[i].remindme != null || _data[i].remindme != '') {
            var arr = _data[i].remindme.split(" ");
            if (arr[1] == "days") {
              _data[i].remindme = arr[0] + " " + _that.dic.l["days"];
            }
            else {
              _data[i].remindme = arr[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
            }
            _data[i].alarmDescription = "(" + _data[i].remindme + " " + _that.dic.l['before'] + ")";
          }
        }

        if (_data[i].alarmtypeid + '' == '18') {
          if (_data[i].remindme != null || _data[i].remindme != '') {

            var arr = _data[i].remindme.split("; ");
            // console.log(arr,'daj da go vidam arr')
            if (arr.length == 1) {
              var arr1 = arr[0].split(" ")
              // console.log(arr[0].split(" "),'1')
              if (arr1[1] == "days") {
                _data[i].remindme = arr1[0] + " " + _that.dic.l["days"];
              }
              else {
                _data[i].remindme = parseInt(arr1[0] * _that.gn.user.metricvalue + '') + " " + _that.gn.user.metric;
                // console.log( _data[i].remindme,'description')
              }
              _data[i].alarmDescription = "(" + _data[i].remindme + " " + _that.dic.l['before'] + ")";

            } else {
              var arr1 = arr[0].split(" ");
              if (arr1[1] == "days") {
                _data[i].remindme = arr1[0] + " " + _that.dic.l["days"];
              }
              else {
                _data[i].remindme = parseInt(arr1[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric);
                // console.log( _data[i].remindme,'description')

                // console.log(arr1[0],'2')
              }

              var arr2 = arr[1].split(" ");
              if (arr2[1] == "days") {
                _data[i].remindme1 = arr2[0] + " " + _that.dic.l["days"];
              }
              else {
                _data[i].remindme1 = arr2[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
                // console.log( _data[i].remindme1,'description2')
                _data[i].remindme1 = parseInt(_data[i].remindme1)

                // console.log( _data[i].remindme1,' aj tek tuka')

              }
              _data[i].alarmDescription = "(" + _data[i].remindme + ", " + _data[i].remindme1 + " " + _that.gn.user.metric + " " + _that.dic.l['before'] + ")";
              // console.log(_data[i].alarmDescription,'daj da te vidam tuka')
            }
          }
        }

        if (_data[i].alarmtypeid + '' == '7') {
          _data[i].alarmDescription = "(" + parseInt(_data[i].speed * _that.gn.user.metricvalue + '') + " " + _that.gn.user.metricspeed + ")";

        }

        if (_data[i].alarmtypeid + '' == '10') {
          _data[i].alarmDescription = "(" + _data[i].poiname + ")\n(" + _data[i].timeofpoi + " " + _that.dic.l['min'] + ")";
        }

        if (_data[i].alarmtypeid + '' == '9' || _data[i].alarmtypeid + '' == '8') {
          _data[i].alarmDescription = "(" + _data[i].poiname + ")";
        }

        if (_data[i].sms == '' || _data[i].sms == null) {
          _data[i].sms = '/';
        }
        if (_data[i].vid != "" || _data[i].vid != null) {

          if (_that.gn.VehiclesDic[_data[i].vehicleid] != undefined) {
            //toa vozilo shto ne e povekje vo clientot ne treba da se pokzhuva
            //zatoa shto e izbrishano od vozila 
            //so alek razmisluvame deka ne treba da gledame nikakov alert za nepostoechko vozilo

            if (_data[i].uniqid == null || _data[i].uniqid == "") {
              _data[i].vehReg = _data[i].registration + " (" + _data[i].code + ")";

              _that.alerts.push(_data[i])
            }
            else {
              if (_data[i].typeofgroup + '' == '2') {
                for (let j = 0; j < _that.gn.Organisations.length; j++) {
                  if (_that.gn.Organisations[j].id == _data[i].settings) {
                    var countVehInOrg = 0;
                    var vehiclesTxt = '';
                    for (let k = 0; k < _that.gn.Vehicles.length; k++) {
                      if (_that.gn.Vehicles[k].organisationid == _that.gn.Organisations[j].id) {
                        countVehInOrg++;

                        vehiclesTxt += _that.gn.Vehicles[k].registration + " (" + _that.gn.Vehicles[k].code + ")\n"
                      }
                    }
                    _data[i].vehReg = _that.gn.Organisations[j].name + " (" + countVehInOrg + ")";
                    _data[i].vehiclesTxt = vehiclesTxt;
                  }
                }
              }
              if (_data[i].typeofgroup + '' == '3') {
                var vehTxt = ''
                for (let k = 0; k < _that.gn.Vehicles.length; k++) {
                  vehTxt += _that.gn.Vehicles[k].registration + " (" + _that.gn.Vehicles[k].code + ")\n"
                }
                _data[i].vehReg = _that.dic.l["allvehicles"] + " (" + _that.gn.Vehicles.length + ")"
                _data[i].vehiclesTxt = vehTxt;
              }

              if (_data[i].uniqid != lastuniqid) {
                _that.alerts.push(_data[i])
                cntUniqID = 1;
              }
              if (lastuniqid == "") {
                lastuniqid = _data[i].uniqid;
              }
              if (_data[i].uniqid == lastuniqid) {
                cntUniqID++;
                //za da gi dava grupirani
              }
            }
          }
          // $lastvar = array('title' => $Title, 'fontveh' => $fontVeh, 'cntallowveh' => $cntAllowVeh, 'row' => $alertrow);
          lastuniqid = _data[i].uniqid;
        }
      }
      // console.log(_that.gn.user.Snooze)
      // console.log(_that.gn.Vehicles)
      // console.log(_that.alerts)
      // console.log(_data);
    })
  }

  editAlert(id: any, a: any) {
    // console.log(a)
    var _that = this
    let modal = this.modalCtrl.create(AlertsaddPage, {
      alertid: id, alert: a, allAlerts: this.origAlerts, fromVeh: this.fromVehicle, cb: function () {
        _that.getAllAlertsforVeh();
      }
    });
    modal.present();
  }

  addNewAlert() {
    var _that = this
    let modal = this.modalCtrl.create(AlertsaddPage, {
      alertid: -1, fromvehicleNew: this.fromVehicleNew, vehicle: this.VehicleID, cb: function () {
        _that.getAllAlertsforVeh();
      }
    });
    modal.present();
  }
  editDriverGrade() {
    // var _that = this
    // let modal = this.modalCtrl.create(AlertsaddPage, {
    //   alertid: -1, fromvehicleNew: this.fromVehicleNew, vehicle: this.VehicleID, cb: function () {
    //     _that.getAllAlertsforVeh();
    //   }
    // });
    // modal.present();
  }

  editVehWorktime() {
    var _that = this
    let modal = this.modalCtrl.create(EditvehshiftsPage, {
      vehicle: this.VehicleID, cb: function () {
        //   _that.getAllAlertsforVeh();
      }
    });
    modal.present();
  }

  excludeArm() {
    var _that = this
    var _vid = this.VehicleID
    this.gn._Post('/api/gn/getexcludearm', { vid: this.gn.crypt(_vid) }, function (_data) {
      let modal = _that.modalCtrl.create(ExcludearmPage, {
        vid: _vid, data: _data, cb: function () {

        }
      });
      modal.present();
    })
  }

  deleteAlert(aid: number, idx: number, auniqid: any) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deletealert"],
      subTitle: _that.dic.l["areyousuredelalert"] + _that.alerts[idx].description,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            var count = 0;
            var ids = [];
            var idsStr = '';
            if (auniqid != null) {
              //brisheme povekje redici vo baza so toa uniqid
              for (let i = 0; i < this.origAlerts.length; i++) {
                if (this.origAlerts[i].uniqid + '' == auniqid + '') {
                  count++;
                  ids.push(this.origAlerts[i].id);
                }
              }

              // console.log("Brisham "+count+" elementi: "+ids.join(','))
              idsStr = ids.join(',');
            }
            else {
              //brisheme samo edna redica
              // console.log("Brisham 1 element: "+aid)
              idsStr = aid + '';
            }
            this.alerts.splice(idx, 1);

            _that.gn.loadWaiting();

            this.gn._Post('/api/gn/deletealarm', { aid: this.gn.crypt(idsStr) }, function (_data) {
              // if(_data.msg=='OK'){
              //_that.getAllAlertsforVeh()
              // _that.vehAlerts.splice(idx, 1);
              _that.gn.loaderWaiting.dismiss();
              // }
            })

            // _that.ionViewDidLoad()
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }



  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  getCurrkm() {
    var _that = this
    //debugger
    var _dat = {
      d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD') + ' ' + _that.selectedTime + ':00'),
      vehid: _that.gn.crypt(_that.VehicleID)
    }
    _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
      _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
      console.log(_that.Odometer, 'ODOMETAR AAAA')
    })
  }

  getCurrEngineWorkTime() {
    var _that = this
    //debugger
    var _dat = {
      d: _that.gn.crypt(moment(_that._ewtDate).format('YYYY-MM-DD') + ' ' + _that.selectedTimeEwt + ':00'),
      vehid: _that.gn.crypt(_that.VehicleID)
    }
    _that.gn._Post('/api/gn/getcurrewt', _dat, function (_data) {
      _that.engineWorkTime = (_data.ewt / 3600).toFixed(2) + '';
      console.log(_that.engineWorkTime, 'EWT AAAA')
    })
  }

  // setAlertsObj(_data) {
  //   var _that = this;
  //   var lastuniqid = "";
  //   var cntUniqID = 0;

  //   for (let i = 0; i < _data.length; i++) {

  //     _data[i].alarmDescription = '';

  //     if (_data[i].alarmtypeid + '' == '17' || _data[i].alarmtypeid + '' == '20') {
  //       if (_data[i].remindme != null || _data[i].remindme != '') {
  //         var arr = _data[i].remindme.split(" ");
  //         if (arr[1] == "days") {
  //           _data[i].remindme = arr[0] + " " + _that.dic.l["days"];
  //         }
  //         else {
  //           _data[i].remindme = arr[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
  //         }
  //         _data[i].alarmDescription = "(" + _data[i].remindme + " " + _that.dic.l['before'] + ")";
  //       }
  //     }

  //     if (_data[i].alarmtypeid + '' == '18') {
  //       if (_data[i].remindme != null || _data[i].remindme != '') {

  //         var arr = _data[i].remindme.split("; ");
  //         if (arr.length == 1) {
  //           var arr1 = arr[0].split(" ")
  //           if (arr1[1] == "days") {
  //             _data[i].remindme = arr1[0] + " " + _that.dic.l["days"];
  //           }
  //           else {
  //             _data[i].remindme = arr1[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
  //           }
  //           _data[i].alarmDescription = "(" + _data[i].remindme + " " + _that.dic.l['before'] + ")";
  //         } else {
  //           var arr1 = arr[0].split(" ");
  //           if (arr1[1] == "days") {
  //             _data[i].remindme = arr1[0] + " " + _that.dic.l["days"];
  //           }
  //           else {
  //             _data[i].remindme = arr1[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
  //           }

  //           var arr2 = arr[1].split(" ");
  //           if (arr2[1] == "days") {
  //             _data[i].remindme1 = arr2[0] + " " + _that.dic.l["days"];
  //           }
  //           else {
  //             _data[i].remindme1 = arr2[0] * _that.gn.user.metricvalue + " " + _that.gn.user.metric;
  //           }
  //           _data[i].alarmDescription = "(" + _data[i].remindme + ", " + _data[i].remindme1 + " " + _that.dic.l['before'] + ")";
  //         }
  //       }
  //     }

  //     if (_data[i].alarmtypeid + '' == '7') {
  //       _data[i].alarmDescription = "(" + _data[i].speed * _that.gn.user.metricvalue + " " + _that.gn.user.metricspeed + ")";
  //     }

  //     if (_data[i].alarmtypeid + '' == '10') {
  //       _data[i].alarmDescription = "(" + _data[i].poiname + ")\n(" + _data[i].timeofpoi + " " + _that.dic.l['min'] + ")";
  //     }

  //     if (_data[i].alarmtypeid + '' == '9' || _data[i].alarmtypeid + '' == '8') {
  //       _data[i].alarmDescription = "(" + _data[i].poiname + ")";
  //     }

  //     if (_data[i].sms == '' || _data[i].sms == null) {
  //       _data[i].sms = '/';
  //     }
  //     if (_data[i].vid != "" || _data[i].vid != null) {

  //       if (_that.gn.VehiclesDic[_data[i].vehicleid] != undefined) {
  //         //toa vozilo shto ne e povekje vo clientot ne treba da se pokzhuva
  //         //zatoa shto e izbrishano od vozila 
  //         //so alek razmisluvame deka ne treba da gledame nikakov alert za nepostoechko vozilo

  //         if (_data[i].uniqid == null || _data[i].uniqid == "") {
  //           _data[i].vehReg = _data[i].registration + " (" + _data[i].code + ")";

  //           _that.vehAlerts.push(_data[i])
  //         }
  //         else {
  //           if (_data[i].typeofgroup + '' == '2') {
  //             for (let j = 0; j < _that.gn.Organisations.length; j++) {
  //               if (_that.gn.Organisations[j].id == _data[i].settings) {
  //                 var countVehInOrg = 0;
  //                 var vehiclesTxt = '';
  //                 for (let k = 0; k < _that.gn.Vehicles.length; k++) {
  //                   if (_that.gn.Vehicles[k].organisationid == _that.gn.Organisations[j].id) {
  //                     countVehInOrg++;

  //                     vehiclesTxt += _that.gn.Vehicles[k].registration + " (" + _that.gn.Vehicles[k].code + ")\n"
  //                   }
  //                 }
  //                 _data[i].vehReg = _that.gn.Organisations[j].name + " (" + countVehInOrg + ")";
  //                 _data[i].vehiclesTxt = vehiclesTxt;
  //               }
  //             }
  //           }
  //           if (_data[i].typeofgroup + '' == '3') {
  //             var vehTxt = ''
  //             for (let k = 0; k < _that.gn.Vehicles.length; k++) {
  //               vehTxt += _that.gn.Vehicles[k].registration + " (" + _that.gn.Vehicles[k].code + ")\n"
  //             }
  //             _data[i].vehReg = _that.dic.l["allvehicles"] + " (" + _that.gn.Vehicles.length + ")"
  //             _data[i].vehiclesTxt = vehTxt;
  //           }
  //           if (lastuniqid == "") {
  //             lastuniqid = _data[i].uniqid;
  //           }
  //           if (_data[i].uniqid == lastuniqid) {
  //             cntUniqID++;
  //             //za da gi dava grupirani
  //           }
  //           if (_data[i].uniqid != lastuniqid) {
  //             _that.vehAlerts.push(_data[i])
  //             cntUniqID = 1;
  //           }
  //         }
  //       }
  //       // $lastvar = array('title' => $Title, 'fontveh' => $fontVeh, 'cntallowveh' => $cntAllowVeh, 'row' => $alertrow);
  //       lastuniqid = _data[i].uniqid;
  //     }
  //   }
  // }

  loadVehicleData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getallvehiclesone', { vid: this.gn.crypt(this.VehicleID) }, function (_data) {
      console.log(_data, 'daj da vidam data na vozilo za allow')

      _that.VehicleData = _data.vehicle[0]
      _that.vehDrivers = _data.drivers

      //_that.vehAlerts = _data.alerts
      // _that.setAlertsObj(_data.alerts)
      // console.log(_that.vehDrivers)
      _that.Title = _that.VehicleData.registration + ' (' + _that.VehicleData.code + ')'
      _that._registration = _that.VehicleData.registration
      _that._sasija = _that.VehicleData.chassisnumber
      _that._firstregistration = moment(_that.VehicleData.firstregistration).format(_that.gn.user.DFormat)
      _that._firstregistrationDT = _that.VehicleData.firstregistration
      _that._code = _that.VehicleData.code
      _that._lastregistration = moment(_that.VehicleData.lastregistration).format(_that.gn.user.DFormat)
      _that._lastregistrationDT = _that.VehicleData.lastregistration
      _that._lastinsurance = moment(_that.VehicleData.lastinsurance).format(_that.gn.user.DFormat)
      _that._lastinsuranceDT = _that.VehicleData.lastinsurance
      _that._lastfireextinguisher = moment(_that.VehicleData.lastfireextinguisher).format(_that.gn.user.DFormat)
      _that._lastfireextinguisherDT = _that.VehicleData.lastfireextinguisher

      _that._intLicenceFrom = moment(_that.VehicleData.internationallicensefrom).format(_that.gn.user.DFormat)
      _that._intLicenceFromDT = _that.VehicleData.internationallicensefrom
      _that._intLicenceTo = moment(_that.VehicleData.internationallicenseto).format(_that.gn.user.DFormat)
      _that._intLicenceToDT = _that.VehicleData.internationallicenseto

      _that._info = _that.VehicleData.alias
      _that._model = _that.VehicleData.model

      if (_that.VehicleData.speedlimitalertallow == 1) { _that._speedlimitalertallow = true }
      if (_that.VehicleData.speedlimitalertenable == 1) { _that._speedlimitalertenable = true }

      _that._speedlimittolerance = _that.VehicleData.speedlimittolerance + ''
      if (_that._speedlimittolerance == '0.00') _that._speedlimittolerance = '0'

      _that._apprkmyear = _that.VehicleData.kmperyear
      _that._summer = _that.VehicleData.springtires
      _that._brand = _that.VehicleData.brand
      _that._myear = _that.VehicleData.pyear
      _that._winter = _that.VehicleData.wintertires
      _that._fueltype = _that.VehicleData.fueltypeid
      _that._printtravelorder = _that.VehicleData.printtravelorder
      _that._sinterval = _that.VehicleData.nextservicemonths
      _that._skm = _that.VehicleData.nextservice
      _that._swh = _that.VehicleData.nextservicewhours
      _that._ounit = _that.VehicleData.organisationid
      // _that._odometer = '0'
      _that._motor = _that.VehicleData.motornumber
      _that.allowCanbas = _that.VehicleData.hasodometer;//allowcanbas

      _that._livevisible = false
      _that._autorenewregistration = false;
      _that._autorenewfireextinguisher = false;

      if (_that.VehicleData.multiplefueltypes == 1) { _that._multiplefueltypes = true }

      if (_that.VehicleData.visible == 1) { _that._livevisible = true }
      if (_that.VehicleData.autorenewregistration == 1) { _that._autorenewregistration = true }
      if (_that.VehicleData.autorenewfireextinguisher == 1) { _that._autorenewfireextinguisher = true }

      _that._fuelcapacity = _that.VehicleData.fuelcapacity
      _that._addequip = _that.VehicleData.addequipment
      _that._greencard = false
      if (_that.VehicleData.greencard == 1) { _that._greencard = true }
      _that._consumptionshow = false
      if (_that.VehicleData.consumptionbyhour == 1) { _that._consumptionshow = true }
      _that._hasfuel = false
      if (_that.VehicleData.hasfuel + '' == '1') { _that._hasfuel = true }
      _that.loadingData = false

      var _ext = _that.getFileExtension(_that.VehicleData.licenceimg)
      _that.licencepdf = _ext == 'pdf' ? _that.VehicleData.licenceimg : '/';

      _that.licenceimg = _ext == 'pdf' ? _that.pdflink : _that.VehicleData.licenceimg;

      if (_that.licenceimg == '') {
        _that.licenceimg = '/'
        _that.licencepdf = '/'
      }

      _that.selectedTimeLastServ = moment(_that.VehicleData.lastservicedtmanual).format("HH:mm")
      _that._lastservicedtmanual = moment(_that.VehicleData.lastservicedtmanual)
      _that._lastservicedtmanualStr = moment(_that._lastservicedtmanual).format('DD-MM-YYYY')
      _that._lastservicedtmanualYMD = moment(_that._lastservicedtmanual).format('YYYY-MM-DD')
      _that._lastservicekmmanual = _that.VehicleData.lastservicekmmanual
    })
  }

  // numericOnly(event): boolean {
  //   let pattern = /^[+-]?([0-9]*[.])?[0-9]+/;
  //   let result = pattern.test(this._speedlimittolerance + '');
  //   return result;
  // }

  openDatePopup(_ev, _lastfirst) {
    var _that = this;
    var datum
    //  = _that._firstregistrationDT
    if (_lastfirst == 'l') {
      datum = _that._lastregistrationDT
    }
    if (_lastfirst == 'odometar') {
      datum = _that._odometarDateYMD
    }
    if (_lastfirst == 'lastservice') {
      datum = _that._lastservicedtmanualYMD
    }
    if (_lastfirst == 'ewt') {
      datum = _that._ewtDateYMD
    }
    if (_lastfirst == 'f') {
      datum = _that._firstregistrationDT
    }
    if (_lastfirst == 'insurance') {
      datum = _that._lastinsuranceDT
    }
    if (_lastfirst == 'fireextinguisher') {
      datum = _that._lastfireextinguisherDT
    }
    if (_lastfirst == 'intLicenceFrom') {
      datum = _that._intLicenceFromDT
    }
    if (_lastfirst == 'intLicenceTo') {
      datum = _that._intLicenceToDT
    }

    let popover = this.popoverCtrl.create(CalendarPage, {
      d: datum, cb: function (d) {
        // console.log(d)
        // if (_lastfirst== 'o'){

        // }
        if (_lastfirst == 'odometar') {
          _that._odometarDate = d;
          _that._odometarDateYMD = moment(_that._odometarDate).format('YYYY-MM-DD')
          _that._odometarDateStr = moment(_that._odometarDate).format('DD-MM-YYYY')
        }
        if (_lastfirst == 'lastservice') {
          _that._lastservicedtmanual = d;
          _that._lastservicedtmanualYMD = moment(_that._lastservicedtmanual).format('YYYY-MM-DD')
          _that._lastservicedtmanualStr = moment(_that._lastservicedtmanual).format('DD-MM-YYYY')
        }

        if (_lastfirst == 'ewt') {
          _that._ewtDate = d;
          _that._ewtDateYMD = moment(_that._ewtDate).format('YYYY-MM-DD')
          _that._ewtDateStr = moment(_that._ewtDate).format('DD-MM-YYYY')
        }
        if (_lastfirst == 'f') {
          _that._firstregistrationDT = d;
          _that._firstregistration = moment(_that._firstregistrationDT).format(_that.gn.user.DFormat)
        }

        if (_lastfirst == 'l') {
          _that._lastregistrationDT = d;
          _that._lastregistration = moment(_that._lastregistrationDT).format(_that.gn.user.DFormat)
        }

        if (_lastfirst == 'insurance') {
          _that._lastinsuranceDT = d;
          _that._lastinsurance = moment(_that._lastinsuranceDT).format(_that.gn.user.DFormat)
        }
        if (_lastfirst == 'fireextinguisher') {
          _that._lastfireextinguisherDT = d;
          _that._lastfireextinguisher = moment(_that._lastfireextinguisherDT).format(_that.gn.user.DFormat)
        }
        if (_lastfirst == 'intLicenceFrom') {
          _that._intLicenceFromDT = d;
          _that._intLicenceFrom = moment(_that._intLicenceFromDT).format(_that.gn.user.DFormat)
        }
        if (_lastfirst == 'intLicenceTo') {
          _that._intLicenceToDT = d;
          _that._intLicenceTo = moment(_that._intLicenceToDT).format(_that.gn.user.DFormat)
        }

        var _dat = {
          // d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD')),
          d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD') + ' ' + _that.selectedTime + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
          _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
        })

        var _dat2 = {
          d: _that.gn.crypt(moment(_that._lastservicedtmanual).format('YYYY-MM-DD') + ' ' + _that.selectedTimeLastServ + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrkm', _dat2, function (_data) {
          _that._lastservicekmmanual = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
        })


        var _dat1 = {
          d: _that.gn.crypt(moment(_that._ewtDate).format('YYYY-MM-DD') + ' ' + _that.selectedTimeEwt + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrewt', _dat1, function (_data) {
          _that.engineWorkTime = (_data.ewt / 3600).toFixed(2) + '';
        })
        //_that.gn.Organisations
      }
    })
    popover.present({ ev: _ev });
  }


  // addDriver() {
  //   var _that = this
  //   let alert = this.alertCtrl.create();
  //   alert.setTitle(this.dic.l["Drivers"]);

  //   var ch = false
  //   if (this.Drivers.length == this.vehDrivers.length)
  //     ch = true;
  //   alert.addInput({
  //     type: 'checkbox',
  //     label: 'Сите',
  //     value: '0',
  //     checked: ch,
  //     handler: (data) => {
  //       if (data.value + '' == '0') {
  //         for (let i = 1; i < alert['instance']['d']['inputs'].length; i++) {
  //           alert['instance']['d']['inputs'][i]['checked'] = alert['instance']['d']['inputs'][0]['checked']
  //         }
  //       }
  //     }
  //   })


  //   for (var i = 0; i < this.Drivers.length; i++) {
  //     ch = false
  //     for (var j = 0; j < this.vehDrivers.length; j++) {
  //       if (this.vehDrivers[j].driverid == this.Drivers[i].id) {
  //         ch = true
  //         break
  //       }
  //     }
  //     alert.addInput({
  //       type: 'checkbox',
  //       label: '(' + this.Drivers[i].code + ') ' + this.Drivers[i].fullname,
  //       value: this.Drivers[i].id,
  //       checked: ch
  //     });
  //   }

  //   alert.addButton(this.dic.l["cancel"]);
  //   alert.addButton({
  //     text: this.dic.l["ok"],
  //     handler: data => {
  //       // this.testRadioOpen = false;
  //       // this.testRadioResult = data;
  //       _that.add2Drivers(data)
  //       // console.log(data)
  //     }
  //   });
  //   alert.present();
  // }

  addDriver2() {
    // var array1 = []
    this.loadDrivers()


    var tempDrivers = []
    tempDrivers = this.Drivers2


    var jj = tempDrivers.length
    console.log(jj)
    while (jj--) {
      // console.log(jj)
      for (let i = 0; i < this.vehDrivers.length; i++) {
        // console.log(this.vehDrivers[i].driverid + '==' + tempDrivers[jj].id)
        if (tempDrivers[jj] != undefined) {
          if (this.vehDrivers[i].driverid == tempDrivers[jj].id) {
            // console.log('dali tuka vlagas')
            tempDrivers.splice(jj, 1)
          }
        }
      }
    }

    var _that = this
    if (this.Drivers.length == this.vehDrivers.length) {
      let alert = this.alertCtrl.create({
        title: this.dic.l["addauthorisedvehicle"],
        subTitle: this.dic.l['allvehchoosen'],
        buttons: [this.dic.l["ok"]]
      });
      alert.present();
    }
    else {

      var _that = this
      let modal = this.modalCtrl.create(PopupadddriverPage, {
        vehicleid: this.VehicleID, leftdrivers: tempDrivers, cb: function (drivers) {

          if (drivers.length > 0) {
            var dr = drivers.filter(function (elem, index, self) {
              return index === self.indexOf(elem);
            })

            for (let i = 0; i < dr.length; i++) {
              for (let j = 0; j < _that.Drivers.length; j++) {
                if (_that.Drivers[j].id == dr[i]) {
                  _that.vehDrivers.push({ id: _that.Drivers[j].id, driverid: _that.Drivers[j].id, fullname: _that.Drivers[j].fullname, code: _that.Drivers[j].code })
                }
              }
            }
          }
        }
      });
      modal.present();
    }
  }

  // add2Drivers(_ids) {
  //   this.vehDrivers = []
  //   for (var i = 0; i < _ids.length; i++) {
  //     for (var j = 0; j < this.Drivers.length; j++) {
  //       if (_ids[i] == this.Drivers[j].id) {
  //         this.vehDrivers.push({ driverid: _ids[i], code: this.Drivers[j].code, fullname: this.Drivers[j].fullname })
  //       }
  //     }
  //   }
  // }

  spliceDriver(_id, _index) {
    this.vehDrivers.splice(_index, 1)
  }

  hasChanges(_what) {
    if (_what == 'fuelcapacity') {
      if (this.VehicleData.fuelcapacity != this._fuelcapacity)
        this._changefuelcap = true;
    }
  }

  confirmChanges(_what) {
    var _mess = '';
    if (_what == 'fuelcapacity') {
      _mess = this.dic.l["usinfo04"]
    }
    var _that = this

    let prompt = this.alertCtrl.create({
      title: this.dic.l["confirmchange"],
      message: this.dic.l["enterpasschange"],
      inputs: [
        {
          name: 'changes',
          placeholder: this.dic.l["password"],
          value: '',
          type: 'password'
        },
      ],
      buttons: [
        {
          text: this.dic.l["cancel"],
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.dic.l["Save"],
          handler: data => {
            var _userpass = localStorage.getItem("user-pass")
            var _tf = _userpass == _that.gn.oldcrypt(data.changes) ? true : false;
            if (_tf) {
              if (_what == 'fuelcapacity') {
                this.doSave();
              }
            } else {
              let toast = _that.gn.toastCtrl.create({
                message: _mess,
                duration: 3000,
                position: 'top'
              });
              toast.present();
              return false;
            }
            console.log('Saved clicked');
          }
        }
      ],
      enableBackdropDismiss: false
    });
    prompt.present();
  }


  nnull(_v, _dv) {
    if (_v === null) {
      return _dv;
    } else {
      return _v;
    }
  }

  nnull1(_v, _dv) {
    if (_v === null || _v == -1) {
      return _dv;
    } else {
      return _v;
    }
  }

  doSave() {
    var vehinfo
    var _drivers = []

    for (var i = 0; i < this.vehDrivers.length; i++) {
      _drivers.push(this.vehDrivers[i].driverid)
    }

    var lv = 0
    if (this._livevisible == true) { lv = 1 }

    var sle = 0
    if (this._speedlimitalertenable == true) { sle = 1 }

    var _hasBuzzerChanges = '';
    if (sle + '' != this.VehicleData.speedlimitalertenable)
      _hasBuzzerChanges = 'enable'
    if ((this.VehicleData.speedlimittolerance + '' != this._speedlimittolerance + ''))
      _hasBuzzerChanges = 'tolerance'
    if (sle + '' != this.VehicleData.speedlimitalertenable && (this.VehicleData.speedlimittolerance + '' != this._speedlimittolerance + ''))
      _hasBuzzerChanges = 'enable|tolerance'


    var areg = 0
    if (this._autorenewregistration == true) { areg = 1 }
    var afe = 0
    if (this._autorenewfireextinguisher == true) { afe = 1 }

    var gc = 0
    if (this._greencard == true) { gc = 1 }

    var cs = 0
    if (this._consumptionshow == true) { cs = 1 }

    var multiplefuel = 0
    if (this._multiplefueltypes == true) { multiplefuel = 1 }

    //vo log da vleze promenata na visible 
    if (this.VehicleData.visible != lv + '') {
      var vida = [];
      vida.push(this.VehicleID);
      var logvozila = ' за возилото: ' + this.gn.getVehiclesLog(vida);
      if (lv + '' == '1') {
        this.gn.addLog(48, logvozila);
      } else {
        this.gn.addLog(49, logvozila);
      }
    }
    // console.log(this.VehicleID, 'daj da zirnam this.VehicleID ')
    // for (let p = 0; p < this.gn.Organisations.length; p++) {
    //  if()
    this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]].organisationid = this._ounit
    this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]].printtravelorder = this._printtravelorder
    // if(this._ounit+'' == '0'){
    //   this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]].organisationid 
    // }

    // this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]] = vehinfo
    // vehinfo.organisationid 

    // console.log(this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]], 'daj da zirnam')
    // }
    // if(this.gn.Organisations)
    // if (this._ounit + '' == '0') {

    //   for (let p = 0; p < this.gn.Organisations.length; p++) {
    //     console.log(this.gn.Organisations[p].orgcolor, 'daj da vidam orgcolor')

    //   }
    //     // this.gn.Organisations
    // }

    // console.log(this._firstregistration)


    var _typerenewregistration = this.VehicleData.typerenewregistration
    if (moment(this.VehicleData.lastregistration).format('YYYY-MM-DD') != moment(this._lastregistrationDT).format('YYYY-MM-DD')) _typerenewregistration = 'manual'

    var _typerenewfireextinguisher = this.VehicleData.typerenewfireextinguisher
    if (moment(this.VehicleData.lastfireextinguisher).format('YYYY-MM-DD') != moment(this._lastfireextinguisherDT).format('YYYY-MM-DD')) _typerenewfireextinguisher = 'manual'



    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      hasBuzzerChanges: this.gn.crypt(_hasBuzzerChanges),
      vid: this.gn.crypt(this.VehicleID),
      drivers: this.gn.crypt(_drivers.join(',')),
      registration: this.gn.crypt(this._registration),
      sasija: this.gn.crypt(this._sasija),
      firstregistration: this.gn.crypt(moment(this._firstregistrationDT).format('YYYY-MM-DD')),
      code: this.gn.crypt(this._code),
      lastregistration: this.gn.crypt(moment(this._lastregistrationDT).format('YYYY-MM-DD')),
      lastinsurance: this.gn.crypt(moment(this._lastinsuranceDT).format('YYYY-MM-DD')),
      lastfireextinguisher: this.gn.crypt(moment(this._lastfireextinguisherDT).format('YYYY-MM-DD')),

      intlicencefrom: this.gn.crypt(moment(this._intLicenceFromDT).format('YYYY-MM-DD')),
      intlicenceto: this.gn.crypt(moment(this._intLicenceToDT).format('YYYY-MM-DD')),

      info: this.gn.crypt(this._info),
      model: this.gn.crypt(this._model),
      speedlimitalertenable: this.gn.crypt(sle),
      speedlimittolerance: this.gn.crypt(parseFloat(this._speedlimittolerance)),
      apprkmyear: this.gn.crypt(this._apprkmyear),
      summer: this.gn.crypt(this._summer),
      brand: this.gn.crypt(this.nnull(this._brand, '')),
      myear: this.gn.crypt(this._myear),
      winter: this.gn.crypt(this._winter),
      fueltype: this.gn.crypt(this._fueltype),
      printtravelorder: this.gn.crypt(this._printtravelorder),
      sinterval: this.gn.crypt(this._sinterval),
      skm: this.gn.crypt(this._skm),
      swh: this.gn.crypt(this._swh),
      ounit: this.gn.crypt(this._ounit),
      odometer: this.gn.crypt(parseFloat(this.Odometer) / this.gn.user.metricvalue),

      //NEW
      lastservicekmmanual: this.gn.crypt(parseFloat(this._lastservicekmmanual) / this.gn.user.metricvalue),
      lastservicekmdatemanual: this.gn.crypt(this._lastservicedtmanualYMD),
      lastservicekmtimemanual: this.gn.crypt(this.selectedTimeLastServ),
      //END NEW

      ewt: this.gn.crypt((parseFloat(this.engineWorkTime) * 3600).toFixed(0)),
      motor: this.gn.crypt(this._motor),
      fuelcapacity: this.gn.crypt(this._fuelcapacity),
      addequipment: this.gn.crypt(this.nnull(this._addequip, '')),
      livevisible: this.gn.crypt(lv),

      autorenewregistration: this.gn.crypt(areg),
      autorenewfireextinguisher: this.gn.crypt(afe),
      typerenewregistration: this.gn.crypt(_typerenewregistration),
      typerenewfireextinguisher: this.gn.crypt(_typerenewfireextinguisher),

      greencard: this.gn.crypt(gc),
      consumptionshow: this.gn.crypt(cs),
      odometerdate: this.gn.crypt(this._odometarDateYMD),
      odometertime: this.gn.crypt(this.selectedTime),
      engineworktimetype: this.gn.crypt(this.gn.Vehicles[this.gn.VehiclesDic[this.VehicleID]].engineworktimetype),
      ewtdate: this.gn.crypt(this._ewtDateYMD),
      ewttime: this.gn.crypt(this.selectedTimeEwt),
      allowcanbas: this.gn.crypt(this.allowCanbas),
      multiplefueltypes: this.gn.crypt(multiplefuel),
      nowdt: this.gn.crypt(moment().format('YYYY-MM-DD HH:MM:SS')),

      licenceimg: this.licencepdf == '/' ? this.gn.crypt(this.licenceimg) : this.gn.crypt(this.licencepdf)

    }

    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    var _that = this
    this.gn._Post('/api/gn/saveVehcile', _dat, function (_data) {
      // _that.navCtrl.pop()
      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
      //_that.gn.enableBtn();
      _that.gn.tfBtn = false;
    })
  }

  Save() {
    if (!(parseInt(this._code) > 0)) {
      let toast = this.toastCtrl.create({ message: this.dic.l["vehcodenumber"], duration: 3000, position: 'top' });
      toast.present();
      return false;
    }

    if (this._changefuelcap) {
      this.confirmChanges('fuelcapacity');
    } else {
      this.doSave()
    }
  }


  probaOdometar() {
    // this.Odometer
    // this._odometarDateYMD
    // console.log(this.Odometer, 'Km')
    // console.log(this._odometarDateYMD, 'Datum')


  }

  openTimePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeodometer', selected: [], callback: function (_text, _ids) {
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedTime = _text;

        var _dat = {
          // d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD')),
          d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD') + ' ' + _that.selectedTime + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
          _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
        })
        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  openTimePopupLastServ(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeodometer', selected: [], callback: function (_text, _ids) {
        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedTimeLastServ = _text;

        var _dat = {
          // d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD')),
          d: _that.gn.crypt(moment(_that._lastservicedtmanual).format('YYYY-MM-DD') + ' ' + _that.selectedTimeLastServ + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
          _that._lastservicekmmanual = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
        })
        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  openTimePopupEwt(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'timeodometer', selected: [], callback: function (_text, _ids) {
        _that.selectedTimeEwt = _text;

        var _dat = {
          // d: _that.gn.crypt(moment(_that._odometarDate).format('YYYY-MM-DD')),
          d: _that.gn.crypt(moment(_that._ewtDate).format('YYYY-MM-DD') + ' ' + _that.selectedTimeEwt + ':00'),
          vehid: _that.gn.crypt(_that.VehicleID)
        }

        _that.gn._Post('/api/gn/getcurrewt', _dat, function (_data) {
          _that.engineWorkTime = (_data.ewt / 3600).toFixed(2) + '';
        })
        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  DeleteQuickmessClick(_messid, _gsm) {
    var _that = this
    let confirm = this.alertCtrl.create({
      title: _that.dic.l["delPredMess"],
      message: _that.dic.l["sureDelMess"],
      buttons: [
        {
          text: this.dic.l["NO"],
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: this.dic.l["YES"],
          handler: () => {
            var _dat = {
              messid: _that.gn.crypt(_messid),
              gsm: _that.gn.crypt(_gsm)
            }
            _that.gn._Post('/api/gn/deleteQuickMess', _dat, function (_data) {
              //
            })
          }
        }
      ]
    });
    confirm.present();
  }

  addQuickMess(_from) {
    var isCheck = false;
    var _toid = '';
    var _text = '';
    if (_from == '0') {
      isCheck = this._messforall
      _text = this._enterpredmess;
      if (_text == '') {
        let toast = this.toastCtrl.create({ message: this.dic.l["entergarminmess"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    } else {
      if (this._vehGarmin == '-1') {
        let toast = this.toastCtrl.create({ message: this.dic.l["choosegarminvehicle"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
      _text = this.gn.Vehicles[this.gn.VehiclesDic[this._vehGarmin]].registration + ': ';
      _toid = this._vehGarmin
    }
    var _that = this
    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      rid: this.gn.crypt(this.gn.user.RoleId),
      vehid: this.gn.crypt(this.VehicleID),
      allcheck: this.gn.crypt(isCheck),
      toid: this.gn.crypt(_toid),
      name: this.gn.crypt(_text)
    }
    _that.gn._Post('/api/gn/addQuickmess', _dat, function (_data) {
      _that.loadGarminQuickMessages();
      _that._enterpredmess = ''
      _that._messforall = false
      _that._vehGarmin = '-1'
    })

    // $.ajax({
    //     url: twopoint + "/main/AddCanned.php?action=add&vehid=" +_id + "&allcheck=" + isCheck + "&toid=" + _toid + "&name=" + kescape(_text) + "&tpoint=" + twopoint,
    //     context: document.body,
    //     success: function (data) {
    //         if(ws != null) {
    //             if(isCheck) {
    //                 var result = data.replace(/\r/g, '').replace(/\n/g, '');
    //                 result = result.split('*');
    //                 for(var i=1; i<result.length; i++) {
    //                     ws.emit('quickmess', result[i].split('|')[0] + '$*^' + _text + '$*^' + result[i].split('|')[1]);
    //                 }
    //             } else {
    //                 ws.emit('quickmess', _gsmnum + '$*^' + _text + '$*^' + data.replace(/\r/g, '').replace(/\n/g, ''));
    //             }
    //             $('#predefmess').load('../main/PredefinedMess.php?id=' + _id, function(){
    //                 $("#txtCannedReg").load('../tracking/garminReloadReg.php?id=' + _id + "&l=" + lang, function(){
    //                     HideWait();
    //                 });
    //             });
    //         }
    //     }
    // });
  }

  changeSegments(name) {
    if (name == 'geninfo') {

    }
    if (name == 'addinfo') {

    }

  }

  getFileExtension(_fname) {
    var tmp = _fname.split('.')
    if (tmp.length > 0) {
      return tmp[tmp.length - 1].toLocaleLowerCase()
    } else {
      return ""
    }
  }

  uploadFileTraining() {
    this.fileInput.nativeElement.click();
  }

  uploadImageFromDekstop(_index, file, _type, _num) {
    var _loader = this.loadingCtrl.create({
      content: this.dic.l["Uploading"],
      duration: 3000
    });
    _loader.present();

    var _that = this
    var reader: any = new FileReader();
    reader.onload = function (e) {
      var _data = e.target.result

      var _poz = _data.indexOf('base64,')
      var _data2 = _data.substring(_poz + 7)

      var _uinq = _that.gn.rndCode() + '-' + _that.gn.rndCode() + '-' + _that.gn.rndCode()

      var _ext = _that.getFileExtension(file.name)

      if (_ext == 'pdf' && file.size > 5000000) {
        const alert = _that.alertCtrl.create({
          title: _that.dic.l["LargeFile"],
          subTitle: _that.dic.l["FileMustBe"],
          buttons: ['OK']
        });
        alert.present();
        return
      }

      _that.gn._PostUploadFile('/api/gn/uploadtempphoto', { file: _data2, ext: _that.gn.crypt(_ext), uniq: _that.gn.crypt(_uinq) }, function (_data) {
        if (_ext == 'pdf') {
          _that.licenceimg = 'https://panorama.gps.mk/costimg/pdf-s.png'
          _that.licencepdf = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
        } else
          _that.licenceimg = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
        _loader.dismiss()
      })
    }
    reader.readAsDataURL(file);
  }


  fileChange(e, idx, type, _num) {
    // debugger
    var isValidExtension = true
    //var allowedExtensions = ["png", "jpg", "jpeg", "gif", "svg", "pdf"]
    var allowedExtensions = ["png", "jpg", "jpeg", "pdf"]
    // debugger
    var fls = e.target.files
    for (var i = 0; i < fls.length; i++) {
      var _ext = this.getFileExtension(fls[i].name)
      // console.log(_ext)
      if (allowedExtensions.indexOf(_ext) == -1) { isValidExtension = false }
      if (isValidExtension == true) {
        this.uploadImageFromDekstop(idx, fls[0], type, _num)
      } else {
        const alert = this.alertCtrl.create({
          title: this.dic.l["InvalidFile"],
          subTitle: this.dic.l["FormatMustBe"] + allowedExtensions.join(', '),
          buttons: ['OK']
        });
        alert.present();
      }
    }
  }
  openImage(_index, imagepath, _typeimage, _num, pdfpath) {
    var _that = this
    //debugger
    let modal = this.modalCtrl.create(ImgcostsPage, {
      index: _index, image: imagepath, typeimage: _typeimage, pdf: pdfpath, cb: function (_idx, _imagepath) {

        _that.licenceimg = _imagepath

      }
    });
    modal.present();

  }
  deleteImg(_num) {
    this.licenceimg = '/'
    this.licencepdf = '/'
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/vehiclesettinngs/vehicleedit.ts